// extracted by mini-css-extract-plugin
export default {"wrapper":"PainScale_wrapper__dMLCA","pain-group":"PainScale_pain-group__zvLql","colored-rectangle":"PainScale_colored-rectangle__dgG8n"};